import { Icon } from "@fluentui/react/lib/Icon";

import { EntityType } from "Model/EntityType";
import { getItemType } from "Utils/Item";
import { useEntityIconStyles } from "./UseEntityIconStyles";
import { IEntityIconProps } from "./IEntityIconProps";

export function EntityIcon(props: IEntityIconProps): JSX.Element {
  const { item, type, styleSet } = props;
  const styles = useEntityIconStyles(styleSet);

  const hasType = type != null;
  const hasItem = item != null;

  if (!hasType && !hasItem) {
    return null;
  }

  const entityType = type != null ? type : getItemType(item);
  return <Icon className={styles.root} iconName={getIconName(entityType)} />;
}

function getIconName(type: EntityType): string {
  if (type === EntityType.Contact) {
    return `Contact`;
  }

  if (type === EntityType.Company) {
    return `CityNext`;
  }

  return `Manufacturing`;
}
